export default "__VITE_ASSET__CTOcd8mB__"